import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { encryptedVideo } from '../../../Interfaces/DataBase/Video';

interface InitialState {
  selectedVideo?: encryptedVideo;
  videosToAssign: encryptedVideo[];
}

const encryptedVideoInitialState: InitialState = {
  selectedVideo: undefined,
  videosToAssign: [],
};

const encryptedVideoSlice = createSlice({
  name: 'encryptedVideos',
  initialState: encryptedVideoInitialState,
  reducers: {
    selectVideo: (state, action: PayloadAction<encryptedVideo>) => {
      state.selectedVideo = action.payload;
    },
    assignNewVideo: (state, action: PayloadAction<encryptedVideo>) => {
      const videoList = [];
      videoList.push({
        Assign: false,
        IsAssigned: false,
        UnAssignedVideoId: action.payload.UnAssignedVideoId,
        VideoName: action.payload.VideoName,
      });
      state.videosToAssign = videoList;
    },
    addVideosToAssign: (state, action: PayloadAction<encryptedVideo>) => {
      const videoList = [...state.videosToAssign];
      videoList.push({
        Assign: false,
        IsAssigned: false,
        UnAssignedVideoId: action.payload.UnAssignedVideoId,
        VideoName: action.payload.VideoName,
      });
      state.videosToAssign = videoList;
    },
    updateUnassignedVideoDetails: (
      state,
      action: PayloadAction<{ index: number; details: encryptedVideo }>
    ) => {
      const videoList = [...state.videosToAssign];
      videoList[action.payload.index] = { ...action.payload.details };
      state.videosToAssign = videoList;
    },
  },
});

export const {
  assignNewVideo,
  selectVideo,
  addVideosToAssign,
  updateUnassignedVideoDetails,
} = encryptedVideoSlice.actions;
export default encryptedVideoSlice.reducer;
